import styled from "styled-components";
import { Link } from "gatsby";
import { colors } from "../../../styles/variables.js";
import { motion } from "framer-motion";

export const Contacts = styled.div`
   display: grid;
   grid-template-columns: 1fr 1fr;
   margin-top: 1.8rem;
   margin-bottom: 1.8rem;

   @media (max-width: 800px) {
      grid-template-columns: 1fr;
   }
`;

export const Contact = styled(motion.div)`
   display: flex;
   flex-direction: column;
   align-items: center;
   padding: 2.2rem 1rem;
`;

export const ContactIcon = styled.a`
   display: flex;
   align-items: center;
   text-decoration: none;
   font-size: 3rem;
   font-weight: 500;
   color: ${colors.primary3};
   transition: color 0.15s ease-in-out;

   &:hover {
      cursor: pointer;
      color: ${colors.accent2};
   }
`;

export const ContactLink = styled.a`
   text-decoration: none;
   font-size: 1.1rem;
   font-weight: 500;
   color: ${colors.primary1};
   margin-top: 1rem;
   transition: color 0.15s ease-in-out;

   &:hover {
      color: ${colors.accent2};
      text-decoration: underline;
      cursor: pointer;
   }
`;
